import React from 'react';
import { ResponsiveContext, Box, Text } from 'grommet';

const Card = ({ name, total, percentage }) => {
  return (
    <ResponsiveContext.Consumer>
      {size => (
        <Box
          round='xsmall'
          width={{ min: 'small', max: 'small' }}
          pad={{
            vertical: size === 'small' ? 'large' : 'medium',
            horizontal: size === 'small' ? 'large' : 'medium',
          }}
          border={{ color: 'light-4' }}
          margin={{ bottom: 'small' }}
        >
          <Box
            direction='row'
            align='end'
            gap='small'
          >
            <Text color='dark-1' size='large'>{total}</Text>
            <Text  color='brand' size='small'>{percentage}</Text>
          </Box>

          <Box
            direction='row'
            justify='between'
            align='center'
            gap='small'
          >
            <Text truncate title={name} size='small' color='dark-6'>{name}</Text>
          </Box>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  )
}

export { Card };
